<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet
  }
});
</script>

<style>
/* Shimmer placeholder shown behind photos until the real image paints.
   aspect-ratio gives the placeholder its width from the img height attribute;
   max-width/height keep it inside its container (cards, thumbnails, modals). */
.delivery-photo {
  display: inline-block;
  aspect-ratio: 4 / 3;
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
  background: linear-gradient(100deg,
    rgba(0, 0, 0, 0.08) 30%,
    rgba(0, 0, 0, 0.16) 50%,
    rgba(0, 0, 0, 0.08) 70%);
  background-size: 200% 100%;
  animation: delivery-photo-shimmer 1.4s ease infinite;
  object-fit: cover;
}
/* Inside ion-thumbnail, Ionic sizes the img to the thumbnail box — defer to it. */
ion-thumbnail .delivery-photo {
  width: 100%;
  height: 100%;
  aspect-ratio: auto;
}
@keyframes delivery-photo-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
</style>